import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";
import { t } from "../i18n";

// Connects to data-controller="product"
export default class extends Controller {
  static targets = [
    "form",
    "colors",
    "size",
    "submit",
    "price",
    "stockStatus",
    "quantity",
  ];

  static values = {
    variantInfoPath: String,
    color: Number,
    size: Number,
    quantity: Number,
  };

  connect() {
    if (this.colorValue && this.sizeValue && this.quantityValue)
      this.updateVariantInfo();
  }

  async updateVariantInfo() {
    const color = this.colorsTargets.find((c) => c.checked)?.value;
    const size = this.sizeTarget.value;

    // Sync selected values to registry form hidden fields
    this.syncRegistryFields(color, size);

    try {
      if (!color && !size) return;

      const res = await get(this.variantInfoPathValue, {
        query: { color_id: color, size_id: size },
      });

      if (!res.ok) {
        this.priceTarget.innerText = t("js.product.option_not_available");
        // this.stock_quantityStatusTarget.innerText = "";
        this.submitTarget.disabled = true;
        return;
      }

      const body = await res.json;

      this.priceTarget.innerText = body.price;
      // this.stock_quantityStatusTarget.innerText = body.available
      // ? `in stock`
      // : "Out of stock";
      this.submitTarget.disabled = !body.available;
    } catch (e) {
      /* handle error */
    }
  }

  // addToCart(e) {
  //   if (
  //     !parseInt(this.quantityTarget.value) &&
  //     !parseInt(this.quantityTarget.value) >= 1
  //   ) {
  //     e.preventDefault();
  //   }
  // }

  sanitizeQuantityValue() {
    this.quantityTarget.value = this.quantityTarget.value
      .replace(/[^0-9.]/g, "")
      .replace(/(\..*?)\..*/g, "$1");

    if (this.quantityTarget.value < 1) this.quantityTarget.value = 1;
    this.syncRegistryQuantity();
  }

  increaseQuantity(e) {
    e.preventDefault();
    this.quantityTarget.value = parseInt(this.quantityTarget.value, 10) + 1;
    this.syncRegistryQuantity();
  }

  decreaseQuantity(e) {
    e.preventDefault();
    if (this.quantityTarget.value > 1) {
      this.quantityTarget.value = parseInt(this.quantityTarget.value, 10) - 1;
    }
    this.syncRegistryQuantity();
  }

  syncRegistryFields(color, size) {
    document.querySelectorAll("[data-registry-color]").forEach((el) => {
      el.value = color || "";
    });
    document.querySelectorAll("[data-registry-size]").forEach((el) => {
      el.value = size || "";
    });
    this.syncRegistryQuantity();
  }

  syncRegistryQuantity() {
    const quantity = this.quantityTarget?.value || 1;
    document.querySelectorAll("[data-registry-quantity]").forEach((el) => {
      el.value = quantity;
    });
  }
}
